/**
 * The Vercel deployment this bundle was built for, if the build was given one.
 * Its own module so the error boundary (`Error.tsx`) stays importable under
 * Jest, whose CommonJS transform cannot compile `import.meta`.
 */
export const VERCEL_DEPLOYMENT_ID: string | undefined = import.meta.env
  .VITE_VERCEL_DEPLOYMENT_ID as string | undefined;
